import { Injectable } from '@angular/core'
import { Router } from '@angular/router'

@Injectable()
export class CanActivateViaAuthGuard {
  constructor(private _router: Router) { }

  canActivate(): boolean {
    // If the user is not logged in we'll send them back to the home page
    if (!window.localStorage.getItem('token')) {
      this._router.navigateByUrl('/auth/login')
      return false
    }
    return true
  }
}
